export default {
  'app.pwa.offline': 'You are currently offline',
  'app.pwa.serviceworker.updated': 'New content available',
  'app.pwa.serviceworker.updated.hint':
    'Please press the "Refresh" button to reload the current page',
  'app.pwa.serviceworker.updated.ok': 'Refresh',
};
